import React, { useState } from "react"
import {
	Button,
	CircularProgress,
	Container,
	Grid,
	IconButton,
	InputAdornment,
	TextField
} from "@material-ui/core"
import {
	Visibility as ShowPassword,
	VisibilityOff as HiddenPassword
} from "@material-ui/icons"

import { Divider, Portlet } from "@/components"

import ApiService from "@/services/Api"
import useValidation from "@/hooks/useValidation"

import useStyles from "@/pages/Auth/styles"
import useQuery from "@/hooks/useQuery"

import logoImg from "@/assets/images/logos/letalk-logo.svg"

import { inboxAppUrl } from "@/config/url"

type ResetRecoveryDataType = {
	password: string
}

const ResetRequest = () => {
	const [resetRecoveryData, setResetRecoveryData] = useState<ResetRecoveryDataType>({}as ResetRecoveryDataType)
	const [loadingResetRecovery, setLoadingResetRecovery] = useState<boolean>(false)
	const [visiblePassword, setVisiblePassword] = useState<boolean>(false)

	const {
		validation,
		clearValidation,
		triggerValidation
	} = useValidation()
	const query = useQuery()
	const classes = useStyles()

	const handleResetDataChange = (type: string, value: string) => {
		setResetRecoveryData({ ...resetRecoveryData, [type]: value })

		clearValidation(type)
	}

	const handleClickShowPassword = () => {
		setVisiblePassword(!visiblePassword)
	}

	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.preventDefault()
	}

	const handleReset = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault()
		setLoadingResetRecovery(true)

		const passwordToken = query.get("token")

		try {
			await ApiService
				.put(`/auth/password/recovery/${passwordToken}`, resetRecoveryData)

			window.location.assign(`${inboxAppUrl.cpURL}/signin`)
		} catch (error) {
			triggerValidation(error)
		}

		setLoadingResetRecovery(false)
	}

	return (
		<Container maxWidth={"md"}>
			<Grid container justify="center" className={classes.authContainer}>
				<Grid item xs={12} sm={10} md={9}>
					<Grid container justify="center" className={classes.authContent}>
						<Grid item xs={12} sm={10} md={9} className={classes.authWrapper}>
							<Portlet elevation={1} className={classes.portlet}>
								<img src={logoImg} alt="Letalk" className={classes.logoImg} />

								<Divider size={4} orientation="horizontal" />
								<form onSubmit={handleReset}>
									<TextField
										id="input-password"
										name="password"
										type={visiblePassword ? "text" : "password"}
										value={resetRecoveryData.password}
										onChange={
											({ target }) => handleResetDataChange("password", target.value)
										}
										variant="outlined"
										label="Nova senha"
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton
														aria-label="alterar visibilidade da senha"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														edge="end"
													>
														{visiblePassword ? <ShowPassword /> : <HiddenPassword />}
													</IconButton>
												</InputAdornment>
											)
										}}
										fullWidth
										helperText={validation.password}
										error={Boolean(validation.password)}
									/>

									<Divider orientation="horizontal" size={4}/>

									<Button
										color="primary"
										variant="contained"
										type='submit'
										disabled={loadingResetRecovery}
										endIcon={loadingResetRecovery && (
											<CircularProgress size={20} color="inherit" />
										)}
										fullWidth
										className={classes.submitButton}
									>
										Alterar senha
									</Button>
								</form>
							</Portlet>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	)
}

export default ResetRequest
